export enum ConfigurationOption {
  On,
  Off,
}

export const ConfigurationOptionMap = new Map<number, string>([
  [ConfigurationOption.On, $localize`:@@shared.configurationOption.txtOn:on`],
  [
    ConfigurationOption.Off,
    $localize`:@@shared.configurationOption.txtOff:off`,
  ],
]);
